import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
	selector: "app-cohorts",
	standalone: true,
	imports: [RouterOutlet],
	templateUrl: "./cohorts.component.html",
	styleUrls: ["./cohorts.component.scss"],
})
export class CohortsComponent {}
